import { DataVersion, IncidentProduct } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useRemoveIncidentReportLogo(
  product: IncidentProduct,
  alarmId: number | string,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({
    product,
    alarm_id: String(alarmId),
  });
  const request = new Request(
    `/v2/orm/location_incidents/report-logo?${searchParams.toString()}`,
    { method: 'DELETE' }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, void>(request, {
    onSuccessInvalidationKeys: [['incidentDetail']],
    onSuccess,
    onError,
    getBody: () => null,
    responseModifier: async () => null,
  });
}

export default useRemoveIncidentReportLogo;
